<div class="menue-wrapper">
  <div class="menue-container">
    <div class="float-left">
      <button matTooltip="Toolbox" class="margin-left-10 margin-right-10 icon-btn" type="button" mat-button
        (click)="toolboxnav.toggle()">
        <mat-icon>business_center</mat-icon>
      </button>
    </div>
    <div class="float-left margin-left-10 margin-right-10 non-material-item">
      <input type="text" autoComplete="off" class="input-layout" matTooltip="Name of layout version"
        [ngModel]="editorService.currentVariant?.name" (ngModelChange)="validateVariantName($event)">
      <div *ngIf="disableSaveButton" class="validation-status">
        {{validationStatus}}
      </div>
    </div>
    <div class="float-left margin-left-right">
      <mat-form-field class="text-center w-350">
        <mat-label>Layout selection</mat-label>
        <mat-select [(value)]="selectedVariant" (selectionChange)="changeVariant($event.value)">
          <mat-option class="select-without-checkbox" *ngFor="let variant of editorInformation?.variantList"
            [value]="variant.id">
            {{variant.name}}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div class="float-left margin-left-10 margin-right-10">
      <mat-form-field class="text-center">
        <mat-label>Deck selection</mat-label>
        <mat-select [(ngModel)]="selectedFloor" [disabled]="floorSource?.length < 2"
          (selectionChange)="changeFloor(selectedFloor)">
          <mat-option class="select-without-checkbox" *ngFor="let deck of floorSource" [value]="deck.id">
            {{deck.name}}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div class="float-left margin-left-10 margin-right-10">
      <mat-form-field class="text-center">
        <mat-label>Layer</mat-label>
        <mat-select [(ngModel)]="selectedLayer" (selectionChange)="changeLayer(selectedLayer)">
          <mat-option class="select-without-checkbox" *ngFor="let layer of layerSource" [value]="layer.id">
            {{ layer.name }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <!-- <div>
      <mat-form-field class="text-center margin-left-right">
        <mat-label>Snapping mode</mat-label>
        <mat-select [(ngModel)]="selectedSnapingMode" (selectionChange)="changeSnapingMode(selectedSnapingMode)">
          <mat-option *ngFor="let snapingMode of snapingModeSource" [value]="snapingMode.id">
            {{ snapingMode.name }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div> -->
    <div class="float-left margin-left-10 margin-right-10 button-group">
      <mat-menu #saveMenu="matMenu">
        <button mat-menu-item matTooltip="Save as" (click)="saveAsDialog()">Save as</button>
      </mat-menu>
      <mat-button-toggle-group class="select-without-checkbox">
        <mat-button-toggle matTooltip="Save" [disabled]="disableSaveButton" (click)="save()">
          <mat-icon class="toolbox-icon">save</mat-icon>
        </mat-button-toggle>
        <mat-button-toggle [matMenuTriggerFor]="saveMenu">
          <mat-icon>arrow_drop_down</mat-icon>
        </mat-button-toggle>
      </mat-button-toggle-group>
    </div>
    <div class="float-right margin-left-auto margin-right-10">
      <button matTooltip="Open visibility control" class="icon-btn" type="button" mat-button
        (click)="toggleNavRight('visibility-control-window')">
        <mat-icon>visibility</mat-icon>
      </button>
      <button mat-button matTooltip="Open measurement control" class="icon-btn" type="button"
        (click)="toggleNavRight('measurement-control-window')">
        <mat-icon>straighten</mat-icon>
      </button>
      <button matTooltip="Open property window" class="icon-btn" type="button" mat-button
        (click)="toggleNavRight('property-window')">
        <mat-icon>build</mat-icon>
      </button>
    </div>
  </div>
  <div class="clearfix"></div>
</div>

<div class="example-container">
  <mat-sidenav-container class="example-sidenav-container" [hasBackdrop]="false">
    <mat-sidenav #toolboxnav [mode]="'over'" class="sidenav-width">
      <!-- Toolbox-Window componnent -->
      <app-toolbox [Config]="toolBoxConfig"></app-toolbox>
    </mat-sidenav>
    <mat-sidenav #navright [mode]="'over'" position="end" class="sidenav-width">
      <!-- Adv-Property-Window componnent -->
      <app-property-window [hidden]="activeNavRightWindow !== 'property-window'"
        [additionalData]="masterData"></app-property-window>
      <app-container-visibility-window [hidden]="activeNavRightWindow !== 'visibility-control-window'"
        [floorContainerList]="floorContainerList" (fileSelected)="onFileSelected($event.event,$event.floorContainer)"
        (backgroundToggled)="toggleBackgroundImageContainer($event)"
        (classContainerToggled)="toggleClassContainer($event)"></app-container-visibility-window>
      <app-measurement-control-window [hidden]="activeNavRightWindow !== 'measurement-control-window'"
        (measurementFeatureStateChanged)="onMeasurementFeatureStateChanged($event)"
        [editorCanvasComponent]="editorCanvasComponent"></app-measurement-control-window>
    </mat-sidenav>
    <mat-sidenav-content>
      <div class="wrapper">
        <!-- Editor-Canvas componnent -->
        <app-editor-canvas></app-editor-canvas>
      </div>
      <div class="bottom-menue-bar">
        <div class="bottom-menue-bar-container">
          <div class="margin-left-right">
            <button matTooltip="Editor command info" class="icon-btn" mat-button (click)="showEditorCommandInfo()">
              <mat-icon>info</mat-icon>
            </button>
          </div>
          <div class="margin-left-right" *ngIf="!environment.production">
            <button matTooltip="Debug" class="icon-btn" mat-button (click)="debug()">
              <mat-icon>adb</mat-icon>
            </button>
          </div>
          <div class="margin-left-right">
            <button matTooltip="Zoom in" class="icon-btn" mat-button (click)="zoomIn()">
              <mat-icon>zoom_in</mat-icon>
            </button>
          </div>
          <div class="margin-left-right">
            <button matTooltip="Zoom out" class="icon-btn" mat-button (click)="zoomOut()">
              <mat-icon>zoom_out</mat-icon>
            </button>
          </div>
        </div>
      </div>
    </mat-sidenav-content>
  </mat-sidenav-container>
</div>